import * as ScrollArea from "@radix-ui/react-scroll-area";
import clsx from "clsx";
import { observer } from "mobx-react";
import Link from "next/link";
import { useRouter } from "next/router";

const SubNav = ({ items }) => {
  const router = useRouter();

  return (
    (<ScrollArea.Root
      className={clsx("SubNav", "relative w-full overflow-hidden border-b")}
    >
      <ScrollArea.Viewport className={clsx("h-full w-full")}>
        <ul className={clsx("SubNav__items", "flex h-full")}>
          {items.map((item) => {
            let isActive = router.asPath === item.href;

            // The isActive should be true if the url starts with the href
            if (item.href !== "/" && router.asPath === item.href) {
              isActive = true;
            }

            // Handle some exceptions
            if (
              item.href === "/saved-recipes" &&
              router.pathname === "/saved-recipes/[id]"
            ) {
              isActive = true;
            }

            return (
              (<li
                key={item.href}
                className={clsx(
                  "group h-full flex-auto last:border-r-0 lg:border-r"
                )}
              >
                <Link
                  href={item.href}
                  className={clsx(
                    "flex h-16 items-center px-6 hover:bg-zinc-100 lg:px-6 lg:group-first:pl-12 2xl:h-20",
                    {
                      "bg-zinc-100": isActive,
                    }
                  )}>

                  <div
                    className={clsx(
                      "SubNav__label",
                      "whitespace-nowrap font-body text-sm font-medium"
                    )}
                  >
                    {item.label}
                  </div>

                </Link>
              </li>)
            );
          })}
        </ul>
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar
        orientation="horizontal"
        className={clsx("hidden")}
      ></ScrollArea.Scrollbar>
    </ScrollArea.Root>)
  );
};

export default observer(SubNav);
